<script>
export default {
    name: "BeforeStart",
    props: ['testId', 'dataProvider'],
    data() {
        return {
            userName: null,
        }
    },
    methods: {
        handleSaveUserName() {
            if (this.userName) {
                this.$router.push({
                    name: 'tests-pass',
                    params: {
                        testId: this.testId,
                        dataProvider: this.dataProvider,
                        userName: this.userName,
                    }
                })
            }
        }
    }
}
</script>

<template>
  <div>
      <v-row>
          <v-col>
              <v-text-field
                  v-model="userName"
                  placeholder="Ваше имя"
                  label="Перед началом теста, введите свое имя"
                  required
              ></v-text-field>

              <v-btn @click="handleSaveUserName" color="primary">Сохранить</v-btn>
          </v-col>
      </v-row>
  </div>
</template>

<style scoped>

</style>
